import request from '@/utils/request.js'
import moment from 'moment'

/**
 * @description 检查用户是否含有新的下单成功订单
 */
export function checkUserHasOrderFinish () {
  return request.get('/OptionOrder/checkUserHasOrderFinish')
}
/**
 * @description 检查用户是否含有新的失败的
 */
export function checkUserHasOrderFail () {
  return request.get('/OptionOrder/checkUserHasOrderFail')
}
/**
 * @author zd
 * @date 2021/11/09
 * @param {* } obj_pageinfo
 * @returns 传入页面信息，返回询价单号
 */
export function getInquirySeriel (obj_pageinfo) {
  // 抽取对象字段
  let inquiryInfo = {}

  // 当前价格
  inquiryInfo.actual_price = parseFloat(obj_pageinfo.actual_price)
  // 参考价格
  inquiryInfo.proposed_price = parseFloat(obj_pageinfo.proposed_price)
  // 行权价格
  inquiryInfo.exercise_price = parseFloat(obj_pageinfo.exercise_price)
  // 到期日
  inquiryInfo.end_date = parseInt(
    moment(obj_pageinfo.end_date).format('YYYYMMDD')
  )
  // 手数
  inquiryInfo.hands = parseInt(obj_pageinfo.hands)
  // 名义参考金额
  inquiryInfo.nominal_amount = parseFloat(obj_pageinfo.nominal_amount)
  //
  inquiryInfo.futu_code = obj_pageinfo.futu_code
  //
  inquiryInfo.buy_or_sell = obj_pageinfo.buy_or_sell
  //
  inquiryInfo.call_or_put = obj_pageinfo.call_or_put
  //
  inquiryInfo.exercise_type = obj_pageinfo.exercise_type

  // 暂时写死 zdtodo
  inquiryInfo.option_type = 'Vanilla'

  return request.post('/OptionOrder/inquiry', JSON.stringify(inquiryInfo))
}

/**
 * @author zd
 * @date 2021/11/09
 * @param {* } 分页信息和时间信息
 * @returns 分页信息；询价清单；每个询价单的详情
 */
export function getInquiryHistory (obj_pageinfo, obj_pickedDate) {
  const params = Object.assign(obj_pageinfo, obj_pickedDate)
  return request.post('/OptionOrder/inquiryList', JSON.stringify(params))
}

/**
 * @author zd
 * @date 2021/11/09
 * @param {* } obj_inquiry_serial
 * @returns 询价序列号对应的询价详情
 */
export function getInquiryDetail (obj_inquiry_serial) {
  return request.post(
    '/OptionOrder/getInquiryDetail',
    JSON.stringify(obj_inquiry_serial)
  )
}

/**
 * @author zd
 * @date 2021/11/09
 * @param {* } obj_order_id
 * @returns 订单号对应的订单详情，包括进行中和已完成
 */
export function getOrderDetail (obj_order_id) {
  return request.post(
    '/OptionOrder/getOrderDetail',
    JSON.stringify(obj_order_id)
  )
}

/**
 * @author zd
 * @date 2021/11/09
 * @param {*} 分页信息和时间信息
 * @returns 进行中的下单清单
 */
export function getInExecutionOrder (obj_pageinfo, obj_pickedDate) {
  const params = Object.assign(obj_pageinfo, obj_pickedDate)
  return request.post(
    '/OptionOrder/getInExecutionOrder',
    JSON.stringify(params)
  )
}

/**
 * @author zd
 * @date 2021/11/09
 * @param {*} 分页信息和时间信息
 * @returns 获取已完成的下单清单
 */
export function getFinishOrder (obj_pageinfo, obj_pickedDate) {
  const params = Object.assign(obj_pageinfo, obj_pickedDate)
  return request.post('/OptionOrder/getFinishOrder', JSON.stringify(params))
}

/**
 * @author zd
 * @date 2021/11/16
 * @param {*} 分页信息和时间信息
 * @returns 获取失败的下单清单
 */
export function getFailOrder (obj_pageinfo, obj_pickedDate) {
  const params = Object.assign(obj_pageinfo, obj_pickedDate)
  return request.post('/OptionOrder/getFailOrder', JSON.stringify(params))
}

/**
 * @author zd
 * @date 2021/11/09
 * @param {*}  无参数
 * @returns 获取交易所和品类，及两者映射关系的数据结构
 */
export function getFutuList () {
  return request.post('/OptionOrder/futuList')
}

/**
 * @author zd
 * @date 2021/11/09
 * @param {*} obj_futu_code
 * @returns 当前价格
 */
export function getActualPrice (obj_futu_code) {
  return request.post(
    '/OptionOrder/selectActualPrice',
    JSON.stringify(obj_futu_code)
  )
}

/**
 * @author zd
 * @date 2021/11/09
 * @param {*} obj_endDate_info
 * @returns 自然日和交易日
 */
export function getFutuTradeDays (obj_endDate_info) {
  return request.post(
    '/OptionOrder/getFutuTradeDays',
    JSON.stringify(obj_endDate_info)
  )
}

/**
 * @author zd
 * @date 2021/11/09
 * @param {*} obj_futu_code
 * @returns 可交易日期（每个品种不一样所需需要查询）；具体交易信息（最大，最小，单位）
 */
export function getFutuDetail (obj_futu_code) {
  return request.post(
    '/OptionOrder/getFutuDetail',
    JSON.stringify(obj_futu_code)
  )
}

/**
 * @author zd
 * @date 2021/11/09
 * @param {*} obj_order_info
 * @returns 目前返回值是失败的
 */
export function toOrder (obj_order_info) {
  obj_order_info.limit_price = parseFloat(obj_order_info.limit_price)

  return request.post('/OptionOrder/order', JSON.stringify(obj_order_info))
}

/**
 * @description 获取该询价单的下单次数
 * @return {"data": 0,"data_time": "2021-11-11 17:20:10","return_code": 0 }
 */

export function getOrderCount (inquiry_serial) {
  return request.post(
    '/OptionOrder/selectOrderCount',
    JSON.stringify(inquiry_serial)
  )
}
/**
 *
 * @param {*} futu_code futucode对象
 * @returns 获取到期日期
 */
export function getTradeDaysByFutuCode (futu_code) {
  return request.post(
    '/OptionOrder/getTradeDaysByFutuCode',
    JSON.stringify(futu_code)
  )
}

/**
 * @description 获取单位
 * @param {*} data
 */
export function getFutuUnit (data) {
  return request.post('/OptionOrder/getFutuUnit', data)
}

/**
 * @description 撤回下单
 * @param {*} data
 */
export function withdrawOptionOrder (data) {
  return request.post('/OptionOrder/withdrawOptionOrder', data)
}
